import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { PresenterType } from '@app/shared';
import { PackageExportReadyMessage } from './package-export-ready.message';

@PresenterType(
{
    model: PackageExportReadyMessage
})
@Component({
  selector: 'package-export-ready-message',
  standalone: false,
  templateUrl: './package-export-ready-message.component.html',
  styleUrl: './package-export-ready-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PackageExportReadyMessageComponent {
  public data: WritableSignal<PackageExportReadyMessage>;

  constructor() {
      this.data = signal<PackageExportReadyMessage>(null);
  }
}
